"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Welcome = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var welcomeBonus = (0, apps_shared_1.useWelcomeBonus)();
    return (react_1.default.createElement(ui_components_1.Modal, { width: "360px", height: "490px", padding: "0" },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: t.raw('welcomeTitle') } })),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, t('welcomeBonusInPopupLine1', {
                        cash: welcomeBonus.maxBonus,
                    })),
                    welcomeBonus.freespins && (react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, t('welcomeBonusInPopupLine2', {
                        freespins: welcomeBonus.freespins,
                    })))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                    react_1.default.createElement(ui_components_1.FixedButton, { onClick: openDeposit }, t('getBonus')))))));
};
exports.default = Welcome;
